<template>
  <div class="left_nav">
    <el-menu :default-active="defaultActiveMenuIndex" :collapse="isCollapse" class="el-menu-vertical-demo">
      <el-menu-item index="7" @click="toNewRouter('gas-over-view')" v-if="permissionCodes.indexOf('046001000') !== -1">
        <i class="el-icon-damai-shujulaiyuan" style="font-size: 16px"></i>
        <span slot="title">概览</span>
      </el-menu-item>
      <el-submenu index="1" v-if="permissionCodes.indexOf('046002000') !== -1 || permissionCodes.indexOf('046002004') !== -1">
        <template slot="title">
          <i class="el-icon-damai-shebei2"></i>
          <span>设备管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="1-1" @click="toNewRouter('gas-controller-management')" v-if="permissionCodes.indexOf('046002000') !== -1">集中器管理</el-menu-item>
          <el-menu-item index="1-2" @click="toNewRouter('gas-ammeter-management')" v-if="permissionCodes.indexOf('046002004') !== -1">燃气表管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <!--<el-menu-item index="5" @click="toNewRouter('gas-account-center')" v-if="permissionCodes.indexOf('004002000') !== -1">-->
      <!--<i class="el-icon-damai-page_shoukuanzhanghu" style="font-size: 20px;"></i>-->
      <!--<span slot="title">收款账户配置</span>-->
      <!--</el-menu-item>-->
      <el-submenu index="2" v-if="permissionCodes.indexOf('046003000') !== -1 || permissionCodes.indexOf('046004000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_ranqipeizhi"></i>
          <span>燃气配置</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="2-1" @click="toNewRouter('gas-config-center')" v-if="permissionCodes.indexOf('046003000') !== -1">收费配置</el-menu-item>
          <el-menu-item index="2-2" @click="toNewRouter('gas-device-scene-config')" v-if="permissionCodes.indexOf('046004000') !== -1">场景配置</el-menu-item>
          <el-menu-item index="2-3" @click="toNewRouter('gas-config-settle')" v-if="permissionCodes.indexOf('046004005') !== -1">结算配置</el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="5" v-if="permissionCodes.indexOf('046005000') !== -1 || permissionCodes.indexOf('046006000') !== -1">
        <template slot="title">
          <i class="el-icon-damai-ic_ranqiyongliangtongji"></i>
          <span slot="title">燃气统计</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="5-1" @click="toNewRouter('gas-quantity')" v-if="permissionCodes.indexOf('046005000') !== -1">按燃气表统计</el-menu-item>
          <el-menu-item index="5-2" @click="toNewRouter('gas-quantity-public')" v-if="permissionCodes.indexOf('046006000') !== -1">按住户统计</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="10" @click="toNewRouter('gas-monitoring')" v-if="permissionCodes.indexOf('046012000') !== -1">
        <i class="el-icon-damai-ic_ranqiyongliangjiance"></i>
        <span slot="title">燃气量监测</span>
      </el-menu-item>
      <el-menu-item index="4" @click="toNewRouter('gas-rent-money')" v-if="permissionCodes.indexOf('046007000') !== -1">
        <i class="el-icon-damai-jiaofeijilu"></i>
        <span slot="title">余额管理</span>
      </el-menu-item>
      <el-menu-item index="3" @click="toNewRouter('gas-pay-record')" v-if="permissionCodes.indexOf('046008000') !== -1">
        <i class="el-icon-damai-page_shoukuanzhanghu" style="font-size: 20px"></i>
        <span slot="title">充值记录</span>
      </el-menu-item>
      <el-menu-item index="9" @click="toNewRouter('gas-settlement-record')" v-if="permissionCodes.indexOf('046009000') !== -1">
        <i class="el-icon-damai-jiesuantongji"></i>
        <span slot="title">结算记录</span>
      </el-menu-item>
      <el-menu-item index="8" @click="toNewRouter('gas-controller-device-status-log')" v-if="permissionCodes.indexOf('046010000') !== -1">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">设备状态日志</span>
      </el-menu-item>
      <el-menu-item index="6" @click="toNewRouter('gas-log')" v-if="permissionCodes.indexOf('046011000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

      <!-- <div style="line-height: 50px;display: flex;justify-content: flex-start;align-items: center;padding-left: 25px;">
        <i class="el-icon-s-fold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = true" v-if="!isCollapse"></i>
        <i class="el-icon-s-unfold" style="font-size: 24px;color: #00a0e6;cursor: pointer;" @click="isCollapse = false" v-if="isCollapse"></i>
      </div> -->
    </el-menu>
  </div>
</template>

<script>
import navMixin from '../../utils/nav'
import { bus } from '../../utils/bus'

const indexOfRouterNameEntities = Object.entries({
  '1-1': ['gas-controller-management', 'gas-controller-add', 'gas-controller-modify', 'gas-controller-current'],
  '1-2': ['gas-ammeter-management', 'gas-ammeter-add', 'gas-ammeter-modify', 'gas-ammeter-current'],
  '2-1': ['gas-config-center', 'gas-config-modify'],
  '2-2': 'gas-device-scene-config',
  '2-3': 'gas-config-settle',
  3: 'gas-pay-record',
  4: 'gas-rent-money',
  // '5': ['gas-account-center', 'gas-account-modify'],
  '5-1': 'gas-quantity',
  '5-2': 'gas-quantity-public',
  6: 'gas-log',
  7: 'gas-over-view',
  8: 'gas-controller-device-status-log',
  9: 'gas-settlement-record',
  10: 'gas-monitoring',
})

export default {
  name: 'gas-management-nav',
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0
        } else {
          return routeNames === routeName
        }
      })
      return entity && entity[0]
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: '',
      indexOfRouterNameEntities,
    }
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
  },
  mounted() {
    bus.vue.$on('changeIsCollapse', (data) => {
      this.isCollapse = data
    })
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@import '../../components/CommonStyle/commonNavStyle';
</style>



// WEBPACK FOOTER //
// src/view/GasManage/GasManagementNav.vue